// extracted by mini-css-extract-plugin
module.exports = {"writingSideways":"Mosttrusted_writingSideways__G7bAW"};